<!-- <div #birdsEyeView style="width: 100%; height: 400px"></div> -->

<div #birdsEyeView style="width: 100%" [style.height.px]="containerHeight || '400'"></div>
